"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortCodeInputWithInfoQuestionWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var InfoQuestionCollapseWrapperWithOptionalFields_1 = require("../../components/infoQuestion/InfoQuestionCollapseWrapperWithOptionalFields");
var SortCodeInputWithInfoQuestionWidget = /** @class */ (function (_super) {
    __extends(SortCodeInputWithInfoQuestionWidget, _super);
    function SortCodeInputWithInfoQuestionWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnBlurEvent = function (event) {
            var sortCode = _this.state.sortCodePart1 + _this.state.sortCodePart2 + _this.state.sortCodePart3;
            _this.props.onStateChange(_this.props.question.interactionField, sortCode);
            _super.prototype.handleOnBlurEvent.call(_this, event);
        };
        _this.handleSortCodePart1ChangeEvent = function (event) {
            var code = event.target.value.replace(/[^0-9.]/g, '');
            var sortCode = code + _this.state.sortCodePart2 + _this.state.sortCodePart3;
            _this.validateInput(sortCode);
            _this.setState({
                sortCodePart1: code
            });
        };
        _this.handleSortCodePart2ChangeEvent = function (event) {
            var code = event.target.value.replace(/[^0-9.]/g, '');
            var sortCode = _this.state.sortCodePart1 + code + _this.state.sortCodePart3;
            _this.validateInput(sortCode);
            _this.setState({
                sortCodePart2: code
            });
        };
        _this.handleSortCodePart3ChangeEvent = function (event) {
            var code = event.target.value.replace(/[^0-9.]/g, '');
            var sortCode = _this.state.sortCodePart1 + _this.state.sortCodePart2 + code;
            _this.validateInput(sortCode);
            _this.setState({
                sortCodePart3: code
            });
        };
        _this.validateInput = function (sortCode) {
            if (sortCode.length !== 6) {
                return true;
            }
            var sortCodeRegex = /^[0-9]{6}$/;
            var isValid = sortCodeRegex.test(sortCode);
            if (isValid) {
                _this.props.validations["sortCodeInputWithInfoQuestion"] = {
                    valid: true,
                    errors: []
                };
            }
            else {
                _this.props.validations["sortCodeInputWithInfoQuestion"] = {
                    valid: false,
                    errors: ["The bank details you've entered are incorrect.\n" +
                            "Please check the sort code and account number provided.\n" +
                            "Alternatively please choose the credit/debit card payment option."]
                };
            }
            return isValid;
        };
        var sortCode = _this.bindFromField(props.question.interactionField);
        var sortCodePart1 = "";
        var sortCodePart2 = "";
        var sortCodePart3 = "";
        if (sortCode && sortCode.length === 6) {
            sortCodePart1 = sortCode.substring(0, 2);
            sortCodePart2 = sortCode.substring(2, 4);
            sortCodePart3 = sortCode.substring(4);
        }
        _this.state = {
            classifier: "",
            sortCodePart1: sortCodePart1,
            sortCodePart2: sortCodePart2,
            sortCodePart3: sortCodePart3,
            serviceError: false
        };
        return _this;
    }
    SortCodeInputWithInfoQuestionWidget.prototype.render = function () {
        var label = this.props.question.label ?
            (0, jsx_runtime_1.jsx)("label", { children: this.props.question.label }) : this.renderHtml(this.getSetting("labelHtml"));
        var additionalText = this.renderHtml(this.getSetting("additionalHtml"));
        return ((0, jsx_runtime_1.jsxs)(InfoQuestionCollapseWrapperWithOptionalFields_1.InfoQuestionCollapseWrapperWithOptionalFields, { label: label, additionalText: additionalText, className: "sort-code-input", children: [this.renderInputField(), this.renderValidationResult()] }));
    };
    SortCodeInputWithInfoQuestionWidget.prototype.renderInputField = function () {
        return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control ".concat(this.getInputValidationClass(), " two-digit-input"), id: this.props.question.name + "bankPart", placeholder: this.props.question.placeHolder, value: this.state.sortCodePart1, onChange: this.handleSortCodePart1ChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, maxLength: 2, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, readOnly: this.isReadOnly() }), (0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control ".concat(this.getInputValidationClass(), " two-digit-input ml-3"), id: this.props.question.name + "regionPart", placeholder: this.props.question.placeHolder, value: this.state.sortCodePart2, onChange: this.handleSortCodePart2ChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, maxLength: 2, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, readOnly: this.isReadOnly() }), (0, jsx_runtime_1.jsx)("input", { type: "text", className: "form-control ".concat(this.getInputValidationClass(), " two-digit-input ml-3"), id: this.props.question.name + "randomPart", placeholder: this.props.question.placeHolder, value: this.state.sortCodePart3, onChange: this.handleSortCodePart3ChangeEvent, onFocus: this.executeNativeEvent, onBlur: this.handleOnBlurEvent, maxLength: 2, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent, readOnly: this.isReadOnly() })] }) }));
    };
    SortCodeInputWithInfoQuestionWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "labelHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "additionalHtml", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], SortCodeInputWithInfoQuestionWidget);
    return SortCodeInputWithInfoQuestionWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.SortCodeInputWithInfoQuestionWidget = SortCodeInputWithInfoQuestionWidget;
//# sourceMappingURL=SortCodeInputWithInfoQuestionWidget.js.map